export const FETCH_NOTARY_CERTIFICATE = 'FETCH_NOTARY_CERTIFICATE';
export const CALCULATE_MERKLE_TREE_ROOT = 'CALCULATE_MERKLE_TREE_ROOT';
export const CALCULATE_CRT_ID = 'CALCULATE_CRT_ID';
export const UPDATE_VALIDATE_MERKLE_STATUS = 'UPDATE_VALIDATE_MERKLE_STATUS';
